import { requestAsync } from "@digitalwing.co/redux-query-immutable";
import endpoints from "api/endpoints";
import { normalize } from "normalizr";
import { offer } from "schemas";

/**
 *
 * @param id {String}
 * @param successCallback {Function}
 * @param errorCallback {Function}
 */
export default ({ id, successCallback, errorCallback }) =>
  requestAsync({
    url: endpoints.getOfferByIdUrl(id),
    queryKey: endpoints.getOfferByIdUrl(),
    transform: (response) => {
      return normalize(response.data, offer.offerSchema).entities;
    },
    transformResult: (response) => ({
      offer: normalize(response.data, offer.offerSchema).result,
    }),
    meta: {
      authToken: true,
      successCallback,
      errorCallback,
    },
    options: {
      headers: {
        Accept: "application/json",
      },
      method: "GET",
    },
    update: {
      offer: (_, result) => result,
    },
    updateResult: {
      offer: (_, result) => result,
    },
  });
